import { render, staticRenderFns } from "./MypackDetail.vue?vue&type=template&id=5a8749b0&"
import script from "./MypackDetail.vue?vue&type=script&lang=js&"
export * from "./MypackDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports